import React, { useState } from 'react';
import './InterestCalculator.css'
import { formatToIndianRupees } from '../../Global/Index'
import { useTheme } from '@mui/material';

const FinancialCalculator = () => {
  const [principal, setPrincipal] = useState(1000000);
  const [rate, setRate] = useState(6);
  const [time, setTime] = useState(10);
  const theme = useTheme();

  const calculateInterest = (principal, rate, time) => {
    const monthlyRate = rate / 12 / 100;
    const numberOfMonths = time * 12;
    const emi = principal == 0 ? 0 : Math.round((principal * monthlyRate * Math.pow(1 + monthlyRate, numberOfMonths)) / (Math.pow(1 + monthlyRate, numberOfMonths) - 1)) + 1;
    return emi;
  };

  const EMI = calculateInterest(principal, rate, time);

  return (

    <div className='maincontainer' style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}
    > <h2>EMI Calculator</h2>
      <div style={{ padding: '2vh' }} >

        <p style={{ margin: '2vh 0vh' }}>* Please use slider or input box to choose value</p>
        <div className='Input'>

          <div className='subInput1'>
            <p>Loan Amount (in ₹) : </p>
            <input
              type='number'
              value={principal}
              onChange={(e) => setPrincipal(Number(e.target.value))}
              placeholder={`${rate} %`}
              style={{ background: theme.palette.maincolor.buttoncolor, color: theme.palette.maincolor.light, textAlign: 'center', width: '83px' }}
            />
          </div>
          <input
            type="range"
            min="0"
            max="10000000"
            value={principal}
            onChange={(e) => setPrincipal(Number(e.target.value))}
          />
        </div>
        <div className='Input'>
          <div className='subInput1'>
            <p>Loan Terms (Years) : </p>
            <input
              type='number'
              value={time}
              onChange={(e) => setTime(Number(e.target.value))}
              placeholder={`${time} `}
              style={{ background: theme.palette.maincolor.buttoncolor, color: theme.palette.maincolor.light, textAlign: 'center', width: '83px' }}
            />
          </div>
          <input
            type="range"
            min="5"
            max="25"
            value={time}
            onChange={(e) => setTime(Number(e.target.value))}
          />
        </div>
        <div className='Input'>
          <div className='subInput1'>
            <p>Rate of interest (in %): </p>
            <input
              type='number'
              value={rate}
              onChange={(e) => setRate(Number(e.target.value))}
              placeholder={`${rate} %`}
              style={{ background: theme.palette.maincolor.buttoncolor, color: theme.palette.maincolor.light, textAlign: 'center', width: '83px' }}

            />
          </div>
          <input
            type="range"
            min="6"
            style={{ color: 'red' }}
            max="20"
            value={rate}
            onChange={(e) => setRate(Number(e.target.value))}
          />
        </div>
        <div className='Data' style={{ backgroundColor: theme.palette.background.default, color: theme.palette.primary.main }}      >
          <h1> EMI  <span>{formatToIndianRupees(EMI)}</span></h1>
        </div>
      </div>
    </div>
  );
};

export default FinancialCalculator;